<template>
  <div>
    <el-tooltip :content="$t('accountSeasonTicket.cancel.btnTooltip')"
                effect="light"
                :open-delay="300"
                placement="bottom">
      <base-button block type="primary" @click="modal = true" :disabled="disabled">
        <i class="tim-icons icon-simple-remove pr-2"/> {{ $t('accountSeasonTicket.cancel.btnLabel') }}
      </base-button>
    </el-tooltip>

    <modal :show.sync="modal"
           showClose
           modal-classes="modal-dialog-centered modal-lg"
           @close="resetForm()">
      <template slot="header">
        <h4 class="modal-title">
          {{ $t('accountSeasonTicket.cancel.titleText') }}
        </h4>
      </template>
      <template>
        <div class="text-center text-muted mb-4">
          <small>{{ $t('accountSeasonTicket.cancel.helpText') }}</small>
        </div>
        <base-alert v-if="alert" dismissible :dismiss-callback="() => alert=false" type="danger">
          <!-- TODO: add error translation -->
          {{ getActionErrorDetails }}
        </base-alert>
        <form role="form" @submit.prevent="validate()">
          <div class="row">
            <label class="col-sm-3 col-form-label">{{ $t('accountSeasonTicket.form.cancelType') }}</label>
            <div class="col-md-9">
              <base-input
                :error="getError('cancelType')">
                <el-select
                  name="cancelType"
                  data-vv-as="'cancelType'"
                  class="select-primary"
                  v-validate="modelValidations.required"
                  v-model="formDetails.status"
                  :placeholder="$t('accountSeasonTicket.form.cancelTypePlaceholder')">
                  <el-option
                    v-for="option in cancelTypes"
                    class="select-primary"
                    :value="option"
                    :label="$t('accountSeasonTicket.cancel.cancelTypes.'+option)"
                    :key="option">
                  </el-option>
                </el-select>
              </base-input>
            </div>
          </div>

          <div class="row">
            <label class="col-sm-3 col-form-label">{{ $t('accountSeasonTicket.form.cancelDescription') }}</label>
            <div class="col-md-9">
              <base-input :error="getError('cancelDescription')">
                <textarea class="form-control"
                          name="cancelDescription"
                          data-vv-as="'cancelDescription'"
                          :placeholder="$t('accountSeasonTicket.form.cancelDescriptionPlaceholder')"
                          v-validate="modelValidations.required"
                          v-model="formDetails.cancel_description"
                          rows="2"/>
              </base-input>
            </div>
          </div>
          <div class="text-center">
            <base-button
              type="primary"
              :loading="updating"
              class="my-4"
              native-type="submit"
            >{{ $t('accountSeasonTicket.cancel.actionBtnLabel') }}
            </base-button>
          </div>
        </form>
      </template>
    </modal>
  </div>
</template>


<script>
import {BaseAlert, Modal} from 'src/components';
import {Option, Select} from 'element-ui';
import {mapActions, mapState} from "vuex";

export default {
  name: 'accountSeasonTicketCancelBtn',
  components: {
    [Option.name]: Option,
    [Select.name]: Select,
    Modal,
    BaseAlert
  },
  data() {
    return {
      modal: false,
      alert: false,
      loading: false,
      formDetails: {
        status: "",
        cancel_description: '',
      },
      modelValidations: {
        required: {
          required: true
        },
      }
    }
  },
  props: {
    disabled: {
      type: Boolean,
      required: true
    },
    accountId: {
      type: String,
      required: true
    },
    id: {
      type: String,
      required: true,
      description: "Account season ticket id",
    },
  },
  computed: {
    ...mapState({
      updating: state => state.account_season_ticket.updating,
      error: state => state.account_season_ticket.error,
      data: state => state.account_season_ticket.data,
      cancelTypes: state => state.account_season_ticket.cancelTypes,
    }),
    getActionErrorDetails() {
      return this.error ? this.error.bodyText : null;
    }
  },
  methods: {
    ...mapActions(['UpdateAccountSeasonTicket', 'LoadAccount']),
    getError(fieldName) {
      return this.errors.first(fieldName);
    },
    validate: function () {
      this.$validator.validateAll().then(isValid => {
        if (isValid) {
          this.create()
        }
      });
    },
    create: function () {
      this.UpdateAccountSeasonTicket({
        ID: this.id,
        accountID: this.accountId,
        payload: this.formDetails,
      }).then(() => {
        if (this.error != null) {
          this.alert = true
          // got error, don't reset form
        } else {
          this.$notify({
            type: 'success',
            message: this.$t('accountSeasonTicket.cancel.successNotification'),
            icon: 'tim-icons icon-alert-circle-exc'
          })
          this.LoadAccount(this.accountId);
          this.resetForm();
        }
      });
    },
    resetForm: function () {
      // closing dialog
      this.modal = false;

      // resetting alerts
      this.alert = false;

      // resetting form
      this.formDetails = {
        status: '',
        cancel_description: '',
      };

      // reset validation errors
      this.$validator.reset()
    }
  }
}
</script>
